const contactInfo = {
  name: 'Prints by Jeroen',
  address: 'Benedenkerkstraat 97',
  postalCode: '5165 CH',
  city: 'Waspik',
  country: 'Nederland',
  phone: '+31681136762',
  email: 'jeroenmeijs@hotmail.com',
//   openingHours: [
//     'Maandag - Vrijdag: 9:00 - 17:00',
//     'Zaterdag: 10:00 - 15:00',
//     'Zondag: Gesloten',
//   ],
  googleMapsUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2462.964282217993!2d4.940963315986934!3d51.69196497966609!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c6a1e2e2e2e2e3%3A0x1234567890abcdef!2sBenedenkerkstraat%2097%2C%205165%20CH%20Waspik!5e0!3m2!1snl!2snl!4v1710000000000!5m2!1snl!2snl'
};

export default contactInfo; 